export default __webpack_public_path__ + "static/media/cer2.2d99a97e.svg";